import { fileReader } from "../../config/utils";
import * as actionTypes from "./constants";
import * as Service from "./services";
import { ERROR_COPY } from "../../config/errorMessages";

const getAllRecommendations = (params, id) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_RECOMMENDATIONS_REQUEST });
            const res = await Service.getAllRecommendations(params, id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_ALL_RECOMMENDATIONS_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_ALL_RECOMMENDATIONS_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_RECOMMENDATIONS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_RECOMMENDATIONS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const addRecommendation = params => {
    let rec_data = new FormData();
    rec_data.append("image", params.image);
    rec_data.append("img_desc", params.img_desc);
    if (params.force_insert) {
        rec_data.append("force_insert", true);
        delete params.force_insert;
    }
    rec_data.append("recommendation", JSON.stringify(params));

    const rData = {
        rec_data,
        recommendation: params
    };
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_RECOMMENDATION_REQUEST });
            const res = await Service.addRecommendation(rec_data);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.ADD_RECOMMENDATION_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({ type: actionTypes.ADD_RECOMMENDATION_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.ADD_RECOMMENDATION_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ADD_RECOMMENDATION_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateRecommendation = (params, id, selectedImage) => {
    let rec_data = new FormData();
    if (selectedImage && params.image && selectedImage?.name !== params?.image?.name) {
        rec_data.append("image", params.image);
    } else if (!params.image_id && params.image) {
        rec_data.append("image", params.image);
    }
    if (params.img_desc) {
        rec_data.append("img_desc", params.img_desc);
    }
    if (params.force_insert) {
        rec_data.append("force_insert", true);
        delete params.force_insert;
    }
    rec_data.append("recommendation", JSON.stringify(params));

    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_RECOMMENDATION_REQUEST });
            const res = await Service.updateRecommendation(rec_data, id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.UPDATE_RECOMMENDATION_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.UPDATE_RECOMMENDATION_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_RECOMMENDATION_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_RECOMMENDATION_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const deleteRecommendation = (id, param) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_RECOMMENDATION_REQUEST });
            const res = await Service.deleteRecommendation(id, param);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.DELETE_RECOMMENDATION_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.DELETE_RECOMMENDATION_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.DELETE_RECOMMENDATION_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_RECOMMENDATION_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getRegionsBasedOnClient = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_REGIONS_BASED_ON_CLIENT_REQUEST });
            const res = await Service.getRegionsBasedOnClient(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_REGIONS_BASED_ON_CLIENT_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_REGIONS_BASED_ON_CLIENT_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_REGIONS_BASED_ON_CLIENT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_REGIONS_BASED_ON_CLIENT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getFloorBasedOnBuilding = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_FLOOR_BASED_ON_BUILDING_REQUEST });
            const res = await Service.getFloorBasedOnBuilding(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_FLOOR_BASED_ON_BUILDING_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_FLOOR_BASED_ON_BUILDING_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_FLOOR_BASED_ON_BUILDING_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_FLOOR_BASED_ON_BUILDING_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getAdditionBasedOnBuilding = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ADDITION_BASED_ON_BUILDING_REQUEST });
            const res = await Service.getAdditionBasedOnBuilding(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_ADDITION_BASED_ON_BUILDING_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_ADDITION_BASED_ON_BUILDING_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ADDITION_BASED_ON_BUILDING_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ADDITION_BASED_ON_BUILDING_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getCategoryBasedOnProject = (id, params, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_CATEGORY_BASED_ON_PROJECT_REQUEST });
            const res = await Service.getCategoryBasedOnProject(id, params, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_CATEGORY_BASED_ON_PROJECT_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_CATEGORY_BASED_ON_PROJECT_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_CATEGORY_BASED_ON_PROJECT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_CATEGORY_BASED_ON_PROJECT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getCapitalTypeBasedOnProject = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_CAPITAL_TYPE_BASED_ON_PROJECT_REQUEST });
            const res = await Service.getCapitalTypeBasedOnProject(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_CAPITAL_TYPE_BASED_ON_PROJECT_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_CAPITAL_TYPE_BASED_ON_PROJECT_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_CAPITAL_TYPE_BASED_ON_PROJECT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_CAPITAL_TYPE_BASED_ON_PROJECT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getSystemBasedOnProject = (id, tradeId, params, source = "") => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SYSTEM_BASED_ON_PROJECT_REQUEST });
            const res = await Service.getSystemBasedOnProject(id, tradeId, params, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_SYSTEM_BASED_ON_PROJECT_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_SYSTEM_BASED_ON_PROJECT_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_SYSTEM_BASED_ON_PROJECT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SYSTEM_BASED_ON_PROJECT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getSubSystemBasedOnProject = (id, systemId, tradeId, params, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SUBSYSTEM_BASED_ON_PROJECT_REQUEST });
            const res = await Service.getSubSystemBasedOnProject(id, systemId, tradeId, params, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_SUBSYSTEM_BASED_ON_PROJECT_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_SUBSYSTEM_BASED_ON_PROJECT_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_SUBSYSTEM_BASED_ON_PROJECT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SUBSYSTEM_BASED_ON_PROJECT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getTradeBasedOnProject = (id, param, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_TRADE_BASED_ON_PROJECT_REQUEST });
            const res = await Service.getTradeBasedOnProject(id, param, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_TRADE_BASED_ON_PROJECT_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_TRADE_BASED_ON_PROJECT_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_TRADE_BASED_ON_PROJECT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_TRADE_BASED_ON_PROJECT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getBuildingsBasedOnSite = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_REGIONS_BASED_ON_CLIENT_REQUEST });
            const res = await Service.getBuildingsBasedOnSite(id);
            // if (res && res.status === 200) {
            //     const regionData = res.data;
            //     if (regionData.success) {
            //         dispatch({
            //             type: actionTypes.GET_REGIONS_BASED_ON_CLIENT_SUCCESS,
            //             response: regionData
            //         });
            //     } else {
            //         dispatch({
            //             type: actionTypes.GET_REGIONS_BASED_ON_CLIENT_FAILURE,
            //             error: regionData
            //         });
            //     }
            // } else {
            //     dispatch({
            //         type: actionTypes.GET_REGIONS_BASED_ON_CLIENT_FAILURE,
            //         error: res.response && res.response.data
            //     });
            // }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_REGIONS_BASED_ON_CLIENT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAllConsultancyUsers = () => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_CONSULTANCY_USERS_REQUEST });
            const res = await Service.getAllConsultancyUsers();
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_ALL_CONSULTANCY_USERS_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_ALL_CONSULTANCY_USERS_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_CONSULTANCY_USERS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_CONSULTANCY_USERS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAllClientsRecomentation = () => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_CLIENTS_REQUEST });
            const res = await Service.getAllClients();
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_ALL_CLIENTS_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.GET_ALL_CLIENTS_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_CLIENTS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_CLIENTS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getRecommendationById = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RECOMMENDATION_BY_ID_REQUEST });
            const res = await Service.getRecommendationById(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_RECOMMENDATION_BY_ID_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_RECOMMENDATION_BY_ID_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_RECOMMENDATION_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_RECOMMENDATION_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const uploadRecommendationImage = (imageData, id) => {
    let newImageData = new FormData();
    newImageData.append("image", imageData.file);
    newImageData.append("description", imageData.comments);

    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPLOAD_IMAGE_REQUEST });
            const res = await Service.uploadImage(newImageData, id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.UPLOAD_IMAGE_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.UPLOAD_IMAGE_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPLOAD_IMAGE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPLOAD_IMAGE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAllRecommendationImages = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_IMAGES_REQUEST });
            const res = await Service.getAllImages(id, params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_ALL_IMAGES_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.GET_ALL_IMAGES_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_IMAGES_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_IMAGES_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const deleteRecommendationImage = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_IMAGES_REQUEST });
            const res = await Service.deleteImages(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.DELETE_IMAGES_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.DELETE_IMAGES_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.DELETE_IMAGES_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_IMAGES_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateRecommendationImageComment = imageData => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_IMAGE_COMMENT_REQUEST });
            const res = await Service.updateImageComment(imageData);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.UPDATE_IMAGE_COMMENT_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({ type: actionTypes.UPDATE_IMAGE_COMMENT_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_IMAGE_COMMENT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_IMAGE_COMMENT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateRecommendationEntityParams = (entityParams, section) => {
    return async dispatch => {
        try {
            if (entityParams) {
                dispatch({
                    type: actionTypes.UPDATE_RECOMMENDATION_ENTITY_PARAMS_SUCCESS,
                    response: entityParams,
                    section
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_RECOMMENDATION_ENTITY_PARAMS_FAILURE,
                error: entityParams,
                section
            });
        }
    };
};

const getListForCommonFilterrecommendation = params => {
    return async dispatch => {
        try {
            dispatch({
                type:
                    params.searchKey === "opinions_cost_vs_project_total"
                        ? actionTypes.GET_OPINIONS_FILTER_REQUEST
                        : actionTypes.GET_LIST_FOR_COMMON_FILTER_REQUEST
            });
            const res = await Service.getListForCommonFilter(params);
            if (res && res.status === 200) {
                const siteData = res.data;
                if (siteData.success) {
                    dispatch({
                        type:
                            params.searchKey === "opinions_cost_vs_project_total"
                                ? actionTypes.GET_OPINIONS_FILTER_SUCCESS
                                : actionTypes.GET_LIST_FOR_COMMON_FILTER_SUCCESS,
                        response: siteData
                    });
                } else {
                    dispatch({
                        type:
                            params.searchKey === "opinions_cost_vs_project_total"
                                ? actionTypes.GET_OPINIONS_FILTER_FAILURE
                                : actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                        error: siteData
                    });
                }
            } else {
                dispatch({
                    type:
                        params.searchKey === "opinions_cost_vs_project_total"
                            ? actionTypes.GET_OPINIONS_FILTER_FAILURE
                            : actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type:
                    params.searchKey === "opinions_cost_vs_project_total"
                        ? actionTypes.GET_OPINIONS_FILTER_FAILURE
                        : actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getCostYearByProject = (projectId, siteId) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_COST_PER_YEAR_BY_PROJECT_REQUEST });
            const res = await Service.getCostYearByProject(projectId, siteId);

            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_COST_PER_YEAR_BY_PROJECT_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_COST_PER_YEAR_BY_PROJECT_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_COST_PER_YEAR_BY_PROJECT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_COST_PER_YEAR_BY_PROJECT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAllRecommendationsRegion = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_RECOMMENDATIONS_REQUEST });
            const res = await Service.getAllRecommendationsRegion(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_ALL_RECOMMENDATIONS_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_ALL_RECOMMENDATIONS_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_RECOMMENDATIONS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_RECOMMENDATIONS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getFundingSourceByProject = (id, params, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_FUNDING_SOURCE_BASED_ON_PROJECT_REQUEST });
            const res = await Service.getFundingSourceByProject(id, params, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_FUNDING_SOURCE_BASED_ON_PROJECT_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_FUNDING_SOURCE_BASED_ON_PROJECT_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_FUNDING_SOURCE_BASED_ON_PROJECT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_FUNDING_SOURCE_BASED_ON_PROJECT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getSpaceType = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SPACE_TYPE_REQUEST });
            const res = await Service.getSpaceType(params);
            if (res && res.status === 200) {
                const data = res.data;
                if (data.success) {
                    dispatch({
                        type: actionTypes.GET_SPACE_TYPE_SUCCESS,
                        response: data
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_SPACE_TYPE_FAILURE,
                        error: data
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_SPACE_TYPE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SPACE_TYPE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getResponsibilityByProject = (id, params, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RESPONSIBILITY_BASED_ON_PROJECT_REQUEST });
            const res = await Service.getResponsibilityByProject(id, params, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_RESPONSIBILITY_BASED_ON_PROJECT_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_RESPONSIBILITY_BASED_ON_PROJECT_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_RESPONSIBILITY_BASED_ON_PROJECT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_RESPONSIBILITY_BASED_ON_PROJECT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getRecommendationAcceptableVerbsByProject = (id, params, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RECOMMENDATION_ACCEPTABLE_VERBS_BASED_ON_PROJECT_REQUEST });
            const res = await Service.getRecommendationAcceptableVerbsByProject(id, params, source);
            if (res && res.status === 200) {
                const verbData = res.data;
                if (verbData.success) {
                    dispatch({
                        type: actionTypes.GET_RECOMMENDATION_ACCEPTABLE_VERBS_BASED_ON_PROJECT_SUCCESS,
                        response: verbData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_RECOMMENDATION_ACCEPTABLE_VERBS_BASED_ON_PROJECT_FAILURE,
                        error: verbData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_RECOMMENDATION_ACCEPTABLE_VERBS_BASED_ON_PROJECT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_RECOMMENDATION_ACCEPTABLE_VERBS_BASED_ON_PROJECT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateMaintenanceYearCutPaste = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_MAINTENANCE_YEARS_CUT_PASTE_REQUEST });
            const res = await Service.updateMaintenanceYearCutPaste(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.UPDATE_MAINTENANCE_YEARS_CUT_PASTE_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.UPDATE_MAINTENANCE_YEARS_CUT_PASTE_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_MAINTENANCE_YEARS_CUT_PASTE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_MAINTENANCE_YEARS_CUT_PASTE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const exportRecommendations = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_REQUEST });
            const res = await Service.exportRecommendations(params);
            if (res && res.status) {
                const exportData = res.data;
                if (res.status === 201) {
                    const name = res.headers["content-disposition"].split("filename=");
                    let fileName = name[1];
                    let downloadUrl = "";
                    let url = window.URL || window.webkitURL;
                    downloadUrl = url.createObjectURL(new Blob([exportData]));

                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", `${fileName}`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return { status: "downloaded" };
                } else if (res.status === 200) {
                    dispatch({
                        type: actionTypes.GET_RECOMMENDATION_EXPORT_SUCCESS,
                        response: { message_status: "Excel Export Initiated, Please check Export History Later", message: exportData.message }
                    });
                    return { status: "queued" };
                } else {
                    dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_FAILURE, error: exportData.message });
                    return { status: "error", message: exportData.message };
                }
            } else {
                dispatch({
                    type: actionTypes.GET_RECOMMENDATION_EXPORT_FAILURE,
                    error: res.response && res.response.data
                });
                return { status: "error" };
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_FAILURE, error: e.response && e.response.data });
            return { status: "error" };
        }
    };
};

const exportAllTrades = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.EXPORT_ALL_TRADES_REQUEST });
            const response = await Service.exportAllTrades(params);
            if (response && response.data) {
                const text = await new Response(response.data).text();
                if (text && text.split('"')[1] === "error") {
                    dispatch({ type: actionTypes.EXPORT_ALL_TRADES_SUCCESS, response: { error: text.split('"')[3] } });
                    return true;
                } else {
                    dispatch({ type: actionTypes.EXPORT_ALL_TRADES_SUCCESS, response: {} });
                }
            }
            const { data } = response;
            const name = response.headers["content-disposition"].split("filename=");
            const fileName = name[1].split('"')[1];
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {}
    };
};

const exportRecommendationByRegion = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_REQUEST });
            const response = await Service.exportRecommendationByRegion(params);
            if (response && response.data) {
                const text = await new Response(response.data).text();
                if (text && text.split('"')[1] === "error") {
                    dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_SUCCESS, response: { error: text.split('"')[3] } });
                    return true;
                } else {
                    dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_SUCCESS, response: {} });
                }
            }
            const { data } = response;
            const name = response.headers["content-disposition"].split("filename=");
            const fileName = name[1].split('"')[1];
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {}
    };
};

const exportRecommendationBySite = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_REQUEST });
            const response = await Service.exportRecommendationBySite(params);
            if (response && response.data) {
                const text = await new Response(response.data).text();
                if (text && text.split('"')[1] === "error") {
                    dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_SUCCESS, response: { error: text.split('"')[3] } });
                    return true;
                } else {
                    dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_SUCCESS, response: {} });
                }
            }
            const { data } = response;
            const name = response.headers["content-disposition"].split("filename=");
            const fileName = name[1].split('"')[1];
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {}
    };
};

const exportRecommendationByBuilding = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_REQUEST });
            const response = await Service.exportRecommendationByBuilding(params);
            if (response && response.data) {
                const text = await new Response(response.data).text();
                if (text && text.split('"')[1] === "error") {
                    dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_SUCCESS, response: { error: text.split('"')[3] } });
                    return true;
                } else {
                    dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_SUCCESS, response: {} });
                }
            }
            const { data } = response;
            const name = response.headers["content-disposition"].split("filename=");
            const fileName = name[1].split('"')[1];
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {}
    };
};

const getRestoreRecommendation = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.RECOVER_RECOMMENDATION_REQUEST });
            const res = await Service.recoverRecommendation(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.RECOVER_RECOMMENDATION_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.RECOVER_RECOMMENDATION_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.RECOVER_RECOMMENDATION_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.RECOVER_RECOMMENDATION_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getConditionBasedOnProject = (id, params, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSET_CONDITION_BASED_ON_PROJECT_REQUEST });
            const res = await Service.getConditionBasedOnProject(id, params, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_ASSET_CONDITION_BASED_ON_PROJECT_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_ASSET_CONDITION_BASED_ON_PROJECT_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ASSET_CONDITION_BASED_ON_PROJECT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ASSET_CONDITION_BASED_ON_PROJECT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getAllRecommendationLogs = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_RECOMMENDATION_LOG_REQUEST });
            const res = await Service.getAllRecommendationLogs(id, params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_ALL_RECOMMENDATION_LOG_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.GET_ALL_RECOMMENDATION_LOG_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_RECOMMENDATION_LOG_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_RECOMMENDATION_LOG_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const restoreRecommendationLog = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.RESTORE_RECOMMENDATION_LOG_REQUEST });
            const res = await Service.restoreRecommendationLog(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.RESTORE_RECOMMENDATION_LOG_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.RESTORE_RECOMMENDATION_LOG_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.RESTORE_RECOMMENDATION_LOG_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.RESTORE_RECOMMENDATION_LOG_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const deleteRecommendationLog = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_RECOMMENDATION_LOG_REQUEST });
            const res = await Service.deleteRecommendationLog(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.DELETE_RECOMMENDATION_LOG_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.DELETE_RECOMMENDATION_LOG_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.DELETE_RECOMMENDATION_LOG_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_RECOMMENDATION_LOG_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getInitiativeDropdown = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_INTITIATIVE_DROPDOWN_REQUEST });
            const res = await Service.getInitiativeDropdown(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_INTITIATIVE_DROPDOWN_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.GET_INTITIATIVE_DROPDOWN_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_INTITIATIVE_DROPDOWN_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_INTITIATIVE_DROPDOWN_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const downloadPdfReport = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DOWNLOAD_PDF_REPORT_REQUEST });
            const res = await Service.downloadPdfReport(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.Result === "Success") {
                    dispatch({ type: actionTypes.DOWNLOAD_PDF_REPORT_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.DOWNLOAD_PDF_REPORT_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.DOWNLOAD_PDF_REPORT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DOWNLOAD_PDF_REPORT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getReportNoteTemplates = (params, dynamicUrl) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_REPORT_NOTE_TEMPLATES_REQUEST });
            const res = await Service.getReportNoteTemplates(params, dynamicUrl);
            if (res && res.status === 200) {
                const reportNoteTemplateData = res.data;
                if (reportNoteTemplateData.success) {
                    dispatch({
                        type: actionTypes.GET_REPORT_NOTE_TEMPLATES_SUCCESS,
                        response: reportNoteTemplateData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_REPORT_NOTE_TEMPLATES_FAILURE,
                        error: reportNoteTemplateData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_REPORT_NOTE_TEMPLATES_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_REPORT_NOTE_TEMPLATES_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const addUserActivityLog = text => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_USER_ACTIVITY_LOG_REQUEST });
            const res = await Service.addUserActivityLog(text);
            if (res && (res.status === 200 || res.status === 201)) {
                const resData = res.data;
                dispatch({ type: actionTypes.ADD_USER_ACTIVITY_LOG_SUCCESS, response: resData });
            } else {
                dispatch({
                    type: actionTypes.ADD_USER_ACTIVITY_LOG_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ADD_USER_ACTIVITY_LOG_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const assignImagesToRecom = (imgData, id) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ASSIGN_IMAGES_TO_RECOM_REQUEST });
            const res = await Service.assignImagesToRecom(imgData, id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.ASSIGN_IMAGES_TO_RECOM_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.ASSIGN_IMAGES_TO_RECOM_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.ASSIGN_IMAGES_TO_RECOM_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ASSIGN_IMAGES_TO_RECOM_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const unAssignImage = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UNASSIGN_IMAGE_REQUEST });
            const res = await Service.unAssignImage(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.UNASSIGN_IMAGE_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.UNASSIGN_IMAGE_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.UNASSIGN_IMAGE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UNASSIGN_IMAGE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const updateRecommendationImageSort = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_RECOMMENDATION_IMAGE_SORT_REQUEST });
            const res = await Service.updateRecommendationImageSort(id, params);
            if (res && res.status === 200) {
                const data = res.data;
                if (data.success) {
                    dispatch({ type: actionTypes.UPDATE_RECOMMENDATION_IMAGE_SORT_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.UPDATE_RECOMMENDATION_IMAGE_SORT_FAILURE, error: data });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_RECOMMENDATION_IMAGE_SORT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_RECOMMENDATION_IMAGE_SORT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateBudgetPriority = (params, id) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_BUDGET_PRIORITY_REQUEST });
            const res = await Service.updateBudgetPriority(params, id);
            if (res && res.status === 200) {
                const budgetData = res.data;
                if (budgetData.success) {
                    dispatch({ type: actionTypes.UPDATE_BUDGET_PRIORITY_SUCCESS, response: budgetData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_BUDGET_PRIORITY_FAILURE, error: budgetData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_BUDGET_PRIORITY_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_BUDGET_PRIORITY_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAllBudgetPriorityRecommendations = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_RECOMMENDATIONS_REQUEST });
            const res = await Service.getAllBudgetPriorityRecommendations(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_ALL_RECOMMENDATIONS_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_ALL_RECOMMENDATIONS_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_RECOMMENDATIONS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_RECOMMENDATIONS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const exportBudgetPriorityRecommendations = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_REQUEST });
            const response = await Service.exportBudgetPriorityRecommendations(params);
            if (response && response.data) {
                const text = await new Response(response.data).text();
                if (text && text.split('"')[1] === "error") {
                    dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_SUCCESS, response: { error: text.split('"')[3] } });
                    return true;
                } else {
                    dispatch({ type: actionTypes.GET_RECOMMENDATION_EXPORT_SUCCESS, response: {} });
                }
            }
            const { data } = response;
            const name = response.headers["content-disposition"].split("filename=");
            const fileName = name[1].split('"')[1];
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {}
    };
};

const getListForBudgetPriorityFilter = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LIST_FOR_COMMON_FILTER_REQUEST });
            const res = await Service.getListForBudgetPriorityFilter(params);
            if (res && res.status === 200) {
                const siteData = res.data;
                if (siteData.success) {
                    dispatch({
                        type: actionTypes.GET_LIST_FOR_COMMON_FILTER_SUCCESS,
                        response: siteData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                        error: siteData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const setRecommendationScrollPosition = pos => {
    return async dispatch => {
        try {
            if (pos) {
                dispatch({
                    type: actionTypes.UPDATE_RECOMMENDATION_SCROLL_POSITION_SUCCESS,
                    response: pos
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_RECOMMENDATION_SCROLL_POSITION_FAILURE,
                error: pos
            });
        }
    };
};

const getRecommendationTemplates = (params, dynamicUrl) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RECOMMENDATION_TEMPLATES_REQUEST });
            const res = await Service.getRecommendationTemplates(params, dynamicUrl);
            if (res && res.status === 200) {
                const recommendationTemplateData = res.data;
                if (recommendationTemplateData.success) {
                    dispatch({
                        type: actionTypes.GET_RECOMMENDATION_TEMPLATES_SUCCESS,
                        response: recommendationTemplateData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_RECOMMENDATION_TEMPLATES_FAILURE,
                        error: recommendationTemplateData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_RECOMMENDATION_TEMPLATES_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_RECOMMENDATION_TEMPLATES_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getUserDefaultTrade = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_USER_DEFAULT_TRADE_REQUEST });
            const res = await Service.getUserDefaultTrade(id);
            if (res && res.status === 200) {
                const resData = res.data;
                if (resData.success) {
                    dispatch({
                        type: actionTypes.GET_USER_DEFAULT_TRADE_SUCCESS,
                        response: resData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_USER_DEFAULT_TRADE_FAILURE,
                        error: resData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_USER_DEFAULT_TRADE_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_USER_DEFAULT_TRADE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateMultipleRecommendations = (data, recomIds, options = {}) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_MULTIPLE_RECOMMENDATIONS_REQUEST });
            const res = await Service.updateMultipleRecommendations(data, recomIds, options);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.UPDATE_MULTIPLE_RECOMMENDATIONS_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.UPDATE_MULTIPLE_RECOMMENDATIONS_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_MULTIPLE_RECOMMENDATIONS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_MULTIPLE_RECOMMENDATIONS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateFMP = (params, id) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_FMP_REQUEST });
            const res = await Service.updateFMP(params, id);
            if (res && res.status === 200) {
                const budgetData = res.data;
                if (budgetData.success) {
                    dispatch({ type: actionTypes.UPDATE_FMP_SUCCESS, response: budgetData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_FMP_FAILURE, error: budgetData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_FMP_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_FMP_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const updateIR = (params, id) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_IR_REQUEST });
            const res = await Service.updateIR(params, id);
            if (res && res.status === 200) {
                const budgetData = res.data;
                if (budgetData.success) {
                    dispatch({ type: actionTypes.UPDATE_IR_SUCCESS, response: budgetData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_IR_FAILURE, error: budgetData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_IR_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_IR_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const updateRL = (params, id) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_RL_REQUEST });
            const res = await Service.updateRL(params, id);
            if (res && res.status === 200) {
                const budgetData = res.data;
                if (budgetData.success) {
                    dispatch({ type: actionTypes.UPDATE_RL_SUCCESS, response: budgetData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_RL_FAILURE, error: budgetData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_RL_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_RL_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateContinuousFCA = (params, id) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_CONTINUOUS_FCA_REQUEST });
            const res = await Service.updateContinuousFCA(params, id);
            if (res && res.status === 200) {
                const budgetData = res.data;
                if (budgetData.success) {
                    dispatch({ type: actionTypes.UPDATE_CONTINUOUS_FCA_SUCCESS, response: budgetData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_CONTINUOUS_FCA_FAILURE, error: budgetData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_CONTINUOUS_FCA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_CONTINUOUS_FCA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getRecommendationCommonDataByIds = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RECOMMENDATION_COMMON_DATA_BY_IDS_REQUEST });
            const res = await Service.getRecommendationCommonDataByIds(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_RECOMMENDATION_COMMON_DATA_BY_IDS_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_RECOMMENDATION_COMMON_DATA_BY_IDS_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_RECOMMENDATION_COMMON_DATA_BY_IDS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_RECOMMENDATION_COMMON_DATA_BY_IDS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getAllRecommendationIds = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_WHOLE_RECOMMENDATION_IDS_REQUEST });
            const res = await Service.getAllRecommendationIds(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_WHOLE_RECOMMENDATION_IDS_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_WHOLE_RECOMMENDATION_IDS_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_WHOLE_RECOMMENDATION_IDS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_WHOLE_RECOMMENDATION_IDS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getPriorityElementDropDownData = projectId => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_PRIORITY_ELEMENT_DROPDOWN_DATA_REQUEST });
            const res = await Service.getPriorityElementDropDownData(projectId);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_PRIORITY_ELEMENT_DROPDOWN_DATA_SUCCESS, response: regionData });
                    return regionData;
                } else {
                    dispatch({ type: actionTypes.GET_PRIORITY_ELEMENT_DROPDOWN_DATA_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_PRIORITY_ELEMENT_DROPDOWN_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_PRIORITY_ELEMENT_DROPDOWN_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

//export pdf report
const exportReportPdf = (params, exportType) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.EXPORT_REPORT_PDF_REQUEST });
            const res = await Service.exportReportPdf(params, exportType);
            if (res && res.data) {
                const { data } = res;
                const name = res.headers["content-disposition"].split("filename=");
                const fileName = name[1].split('"')[1];
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", `${fileName}`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        } catch (e) {}
    };
};
//export multiple recommendations (word file)
const exportSelectedRecomWord = params => {
    return async () => {
        try {
            const res = await Service.exportSelectedRecomWord(params);
            if (res && res.data) {
                const text = await new Response(res.data).text();
                const { data } = res;
                const name = res.headers["content-disposition"].split("filename=");
                const fileName = name[1].split('"')[1];
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", `${fileName}`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        } catch (e) {}
    };
};
//export multiple recommendations (pdf file)
const exportSelectedRecomPDF = params => {
    return async () => {
        try {
            const res = await Service.exportSelectedRecomPDF(params);
            if (res && res.data) {
                const { data } = res;
                const name = res.headers["content-disposition"].split("filename=");
                const fileName = name[1].split('"')[1];
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", `${fileName}`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        } catch (e) {}
    };
};

const getCriticalityDropDownData = projectId => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_CRITICALITY_DROPDOWN_DATA_REQUEST });
            const res = await Service.getCriticalityDropDownData(projectId);
            if (res && res.status === 200) {
                const criticalityData = res.data;
                if (criticalityData.success) {
                    dispatch({ type: actionTypes.GET_CRITICALITY_DROPDOWN_DATA_SUCCESS, response: criticalityData });
                } else {
                    dispatch({ type: actionTypes.GET_CRITICALITY_DROPDOWN_DATA_FAILURE, error: criticalityData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_CRITICALITY_DROPDOWN_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_CRITICALITY_DROPDOWN_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getImportViewTableModal = (params, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_IMPORT_VIEW_TABLE_REQUEST });
            const res = await Service.getImportViewTableModal(params, source);
            if (res && res.status === 200) {
                const criticalityData = res.data;
                if (criticalityData.success) {
                    dispatch({ type: actionTypes.GET_IMPORT_VIEW_TABLE_SUCCESS, response: criticalityData });
                } else {
                    dispatch({ type: actionTypes.GET_IMPORT_VIEW_TABLE_FAILURE, error: criticalityData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_IMPORT_VIEW_TABLE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_IMPORT_VIEW_TABLE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const exportToWord = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_EXPORT_WORD_DATA_REQUEST });
            const res = await Service.exportToWord(params);
            // Returned outcome ({ status: "downloaded" | "queued" | "error" }) mirrors exportRecommendations,
            // so Otto (table_view export) reports what actually happened; existing callers ignore the return.
            if (res && res.status) {
                const wordData = res.data;
                if (res.status === 201) {
                    const { data } = res;
                    const link = document.createElement("a");
                    link.href = data.doc_url;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    dispatch({
                        type: actionTypes.GET_EXPORT_WORD_DATA_SUCCESS,
                        response: { message_status: "File Exported Successfully", message: data.message }
                    });
                    return { status: "downloaded" };
                } else if (res.status === 200) {
                    dispatch({
                        type: actionTypes.GET_EXPORT_WORD_DATA_SUCCESS,
                        response: { message_status: "Word Export Initiated, Please check Export History Later", message: wordData.message }
                    });
                    return { status: "queued" };
                } else {
                    dispatch({ type: actionTypes.GET_EXPORT_WORD_DATA_FAILURE, error: wordData.message });
                    return { status: "error", message: wordData.message };
                }
            } else {
                dispatch({
                    type: actionTypes.GET_EXPORT_WORD_DATA_FAILURE,
                    error: res.response && res.response.data
                });
                return { status: "error" };
            }
        } catch (e) {
            if (e.response?.status === 406) {
                const { message } = e.response?.data || {};
                const message_status =
                    message === "file_not_exist" ? "Uploaded Template File Not Exist" : "Settings Not Found Or Template File Not Found";
                dispatch({
                    type: actionTypes.GET_EXPORT_WORD_DATA_SUCCESS,
                    response: { message_status, message }
                });
                return { status: "error", message: message_status };
            } else if (e.response?.status === 415) {
                dispatch({
                    type: actionTypes.GET_EXPORT_WORD_DATA_SUCCESS,
                    response: { message_status: "Unsupported Media Type", message: e.response.data?.message }
                });
                return { status: "error", message: "Unsupported Media Type" };
            } else {
                dispatch({ type: actionTypes.GET_EXPORT_WORD_DATA_FAILURE, error: e.response && e.response.data });
                return { status: "error" };
            }
        }
    };
};
const exportToExcelFile = (params, type) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_EXPORT_EXCEL_DATA_REQUEST });
            const res = type === "crossWalk" ? await Service.exportCrossWalkExcel(params) : await Service.exportToExcelFile(params);
            // Returned outcome ({ status: "downloaded" | "queued" | "error" }) mirrors exportRecommendations,
            // so Otto (table_view export) reports what actually happened; existing callers ignore the return.
            // NOTE: this endpoint's statuses are the REVERSE of exportRecommendations' (200 = inline file,
            // 201 = queued background job).
            if (res && res?.status) {
                const excelData = res?.data;
                if (res?.status === 200) {
                    const name = res.headers["content-disposition"].split("filename=");
                    const fileName = name[1];
                    const downloadUrl = window.URL.createObjectURL(new Blob([excelData]));
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", `${fileName}`); //any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    dispatch({
                        type: actionTypes.GET_EXPORT_EXCEL_DATA_SUCCESS,
                        response: { message_status: "File Exported Successfully" }
                    });
                    return { status: "downloaded" };
                } else if (res.status === 201) {
                    dispatch({
                        type: actionTypes.GET_EXPORT_EXCEL_DATA_SUCCESS,
                        response: { message_status: "Excel Export Initiated, Please check Export History Later", message: excelData?.message }
                    });
                    return { status: "queued" };
                } else {
                    dispatch({ type: actionTypes.GET_EXPORT_EXCEL_DATA_FAILURE, error: excelData?.message });
                    return { status: "error", message: excelData?.message };
                }
            }
            return { status: "error" };
        } catch (e) {
            if (e.response?.status === 406 || e.response?.status === 404) {
                const file = await fileReader(e.response.data);
                const { message } = JSON.parse(file);
                const message_status =
                    message === "file_not_exist" ? "Uploaded Template File Not Exist" : "Settings Not Found Or Template File Not Found";
                dispatch({
                    type: actionTypes.GET_EXPORT_EXCEL_DATA_SUCCESS,
                    response: { message_status, message }
                });
                return { status: "error", message: message_status };
            } else if (e.response?.status === 415) {
                dispatch({
                    type: actionTypes.GET_EXPORT_EXCEL_DATA_SUCCESS,
                    response: { message_status: "Unsupported Media Type", message: e.response.data?.message }
                });
                return { status: "error", message: "Unsupported Media Type" };
            } else {
                dispatch({ type: actionTypes.GET_EXPORT_EXCEL_DATA_FAILURE, error: e?.response && e.response?.data });
                return { status: "error" };
            }
        }
    };
};

const getCapitalTypeDropDownData = (projectId, params, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_CAPITAL_TYPE_DROPDOWN_DATA_REQUEST });
            const res = await Service.getCapitalTypeDropDownData(projectId, params, source);
            if (res && res.status === 200) {
                const capitalTypeData = res.data;
                if (capitalTypeData.success) {
                    dispatch({ type: actionTypes.GET_CAPITAL_TYPE_DROPDOWN_DATA_SUCCESS, response: capitalTypeData });
                } else {
                    dispatch({ type: actionTypes.GET_CAPITAL_TYPE_DROPDOWN_DATA_FAILURE, error: capitalTypeData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_CAPITAL_TYPE_DROPDOWN_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_CAPITAL_TYPE_DROPDOWN_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateNoteImportViewTableModal = (params, id) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_NOTE_REQUEST });
            const res = await Service.updateNoteImportViewTableModal(params, id);
            if (res && res.status === 200) {
                const export_note = res.data;
                if (export_note.success) {
                    dispatch({ type: actionTypes.UPDATE_NOTE_SUCCESS, response: export_note });
                } else {
                    dispatch({ type: actionTypes.UPDATE_NOTE_FAILURE, error: export_note });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_NOTE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_NOTE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

// const exportToExcel= params => {
//     return async () => {
//         try {
//             const res = await Service.getExportExcelFromExport(params);
//             if (res && res.data) {
//                 const text = await new Response(res.data).text();
//                 const { data } = res;
//                 const name = res.headers["content-disposition"].split("filename=");
//                 const fileName = name[1].split('"')[1];
//                 const downloadUrl = window.URL.createObjectURL(new Blob([data]));
//                 const link = document.createElement("a");
//                 link.href = downloadUrl;
//                 link.setAttribute("download", `${fileName}`); //any other extension
//                 document.body.appendChild(link);
//                 link.click();
//                 link.remove();
//                 // const { data } = res;
//                 // const link = document.createElement("a");
//                 // link.href = data.doc_url;
//                 // document.body.appendChild(link);
//                 // link.click();
//                 // link.remove();
//             }
//         } catch (e) {}
//     };
// };

const exportToExcel = (params, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.EXPORT_EXCEL_HISTORY_REQUEST });
            const response = await Service.getExportExcelFromExport(params, source);
            if (response && response.data) {
                const text = await new Response(response.data).text();
                if (text && text.split('"')[1] === "error") {
                    dispatch({ type: actionTypes.EXPORT_EXCEL_HISTORY_FAILURE, response: { error: text.split('"')[3] } });
                    return true;
                } else {
                    dispatch({ type: actionTypes.EXPORT_EXCEL_HISTORY_SUCCESS, response: {} });
                }
            }
            const { data } = response;
            const name = response.headers["content-disposition"].split("filename=");
            const fileName = name[1];
            let blob = new Blob([data]);
            let url = window.URL || window.webkitURL;
            let downloadUrl = url.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {
            dispatch({
                type: actionTypes.EXPORT_EXCEL_HISTORY_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getExportRecom = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_EXPORT_ITEMS_REQUEST });
            const res = await Service.getExportRecom(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_EXPORT_ITEMS_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.GET_EXPORT_ITEMS_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_EXPORT_ITEMS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_EXPORT_ITEMS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const postExportRecom = params => {
    return async dispatch => {
        let exportData = new FormData();
        params.s3_file && exportData.append("s3_file", params.s3_file);
        exportData.append("project_id", params.project_id);
        exportData.append("properties", JSON.stringify(params.properties));
        exportData.append("recom_property", params.recom_property);
        params?.is_smart_chart && exportData.append("is_smart_chart", params?.is_smart_chart);
        params?.create_new && exportData.append("create_new", params?.create_new);
        params?.settings_id && exportData.append("settings_id", params?.settings_id);
        try {
            dispatch({ type: actionTypes.ADD_EXPORT_ITEMS_REQUEST });

            const res = await Service.postExportRecom(exportData);
            if (res && res.status === 200) {
                const regionData = res.data;
                const text = await new Response(res.data).text();
                if (text.status) {
                    dispatch({
                        type: actionTypes.ADD_EXPORT_ITEMS_SUCCESS,
                        response: JSON.parse(text)
                    });
                } else {
                    dispatch({ type: actionTypes.ADD_EXPORT_ITEMS_FAILURE, error: JSON.parse(text) });
                }
            } else {
                dispatch({
                    type: actionTypes.ADD_EXPORT_ITEMS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ADD_EXPORT_ITEMS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getExportPropertyDropdown = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_EXPORT_PROPERTY_DROPDOWN_REQUEST });
            const res = await Service.getExportPropertyDropdown(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                dispatch({ type: actionTypes.GET_EXPORT_PROPERTY_DROPDOWN_SUCCESS, response: regionData });
            } else {
                dispatch({
                    type: actionTypes.GET_EXPORT_PROPERTY_DROPDOWN_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_EXPORT_PROPERTY_DROPDOWN_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getDynamicFields = (params, type) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_FIELDS_REQUEST });
            const res = type === "reference" ? await Service.getReferenceDynamicFieldsByScope(params) : await Service.getDynamicFields(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_DYNAMIC_FIELDS_SUCCESS, response: regionData });
                    // Returned (like getPriorityElementDropDownData) so a caller awaiting the thunk can
                    // capture the payload for the exact scope it asked for (Otto stamps it by scope key).
                    return regionData;
                } else {
                    dispatch({ type: actionTypes.GET_DYNAMIC_FIELDS_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_DYNAMIC_FIELDS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_DYNAMIC_FIELDS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const createQaQcIssue = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.CREATE_QAQC_ISSUE_REQUEST });
            const res = await Service.createQaQcIssue(params);
            if (res && res.status === 200) {
                const createQaQc = res.data;
                if (createQaQc.status) {
                    dispatch({
                        type: actionTypes.CREATE_QAQC_ISSUE_SUCCESS,
                        response: createQaQc
                    });
                } else {
                    dispatch({
                        type: actionTypes.CREATE_QAQC_ISSUE_FAILURE,
                        response: createQaQc
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.CREATE_QAQC_ISSUE_FAILURE,
                    error: res.response && res.response.data,
                    message: ERROR_COPY.GENERIC
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.CREATE_QAQC_ISSUE_FAILURE,
                error: e.response && e.response.data,
                message: ERROR_COPY.GENERIC
            });
        }
    };
};

const getAllRecommendationReviews = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_RECOMMENDATION_REVIEWS_REQUEST });
            const res = await Service.getAllRecommendationReviews(params);
            if (res && res.status === 200) {
                const allQaQcReviews = res.data;
                if (allQaQcReviews.success) {
                    dispatch({
                        type: actionTypes.GET_ALL_RECOMMENDATION_REVIEWS_SUCCESS,
                        response: allQaQcReviews
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_ALL_RECOMMENDATION_REVIEWS_FAILURE,
                        error: allQaQcReviews
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_RECOMMENDATION_REVIEWS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_RECOMMENDATION_REVIEWS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateRecommendationReview = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_RECOMMENDATION_REVIEW_REQUEST });
            const res = await Service.updateRecommendationReview(id, params);
            if (res && res.status === 200) {
                const updateReview = res.data;
                if (updateReview.success) {
                    dispatch({
                        type: actionTypes.UPDATE_RECOMMENDATION_REVIEW_SUCCESS,
                        response: { ...updateReview, updatedId: id }
                    });
                } else {
                    dispatch({
                        type: actionTypes.UPDATE_RECOMMENDATION_REVIEW_FAILURE,
                        error: updateReview
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_RECOMMENDATION_REVIEW_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_RECOMMENDATION_REVIEW_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateRecommendationReviewStatusReviewer = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_REVIEW_STATUS_REVIEWER_REQUEST });
            const res = await Service.updateRecommendationReviewStatusReviewer(id, params);
            if (res && res.status === 200) {
                const updateReview = res.data;
                if (updateReview.success) {
                    dispatch({
                        type: actionTypes.UPDATE_REVIEW_STATUS_REVIEWER_SUCCESS,
                        response: { ...updateReview, updatedId: id }
                    });
                } else {
                    dispatch({
                        type: actionTypes.UPDATE_REVIEW_STATUS_REVIEWER_FAILURE,
                        error: updateReview
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_REVIEW_STATUS_REVIEWER_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_REVIEW_STATUS_REVIEWER_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateRecommendationReviewStatusUser = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_REVIEW_STATUS_REVIEWER_REQUEST });
            const res = await Service.updateRecommendationReviewStatusUser(id, params);
            if (res && res.status === 200) {
                const updateReview = res.data;
                if (updateReview.success) {
                    dispatch({
                        type: actionTypes.UPDATE_REVIEW_STATUS_REVIEWER_SUCCESS,
                        response: { ...updateReview, updatedId: id }
                    });
                } else {
                    dispatch({
                        type: actionTypes.UPDATE_REVIEW_STATUS_REVIEWER_FAILURE,
                        error: updateReview
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_REVIEW_STATUS_REVIEWER_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_REVIEW_STATUS_REVIEWER_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const deleteRecommendationReview = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_REVIEW_REQUEST });
            const res = await Service.deleteRecommendationReview(id);
            if (res && res.status === 200) {
                const updateReview = res.data;
                if (updateReview.success) {
                    dispatch({
                        type: actionTypes.DELETE_REVIEW_SUCCESS,
                        response: { ...updateReview, updatedId: id }
                    });
                } else {
                    dispatch({
                        type: actionTypes.DELETE_REVIEW_FAILURE,
                        error: updateReview
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.DELETE_REVIEW_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_REVIEW_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const sendQaQcAllNotification = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.SEND_ALL_NOTIFICATION_REQUEST });
            const res = await Service.sendAllReviewNotifications(params);
            if (res && res.status === 200) {
                const updateReview = res.data;
                if (updateReview.success) {
                    dispatch({
                        type: actionTypes.SEND_ALL_NOTIFICATION_SUCCESS,
                        response: updateReview
                    });
                } else {
                    dispatch({
                        type: actionTypes.SEND_ALL_NOTIFICATION_FAILURE,
                        error: updateReview
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.SEND_ALL_NOTIFICATION_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.SEND_ALL_NOTIFICATION_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const sendReviewNotification = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.SEND_REVIEW_NOTIFICATION_REQUEST });
            const res = await Service.sendReviewNotification(params);
            if (res && res.status === 200) {
                const updateReview = res.data;
                if (updateReview.success) {
                    dispatch({
                        type: actionTypes.SEND_REVIEW_NOTIFICATION_SUCCESS,
                        response: updateReview
                    });
                } else {
                    dispatch({
                        type: actionTypes.SEND_REVIEW_NOTIFICATION_FAILURE,
                        error: updateReview
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.SEND_REVIEW_NOTIFICATION_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.SEND_REVIEW_NOTIFICATION_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const qaQcPassedUpdate = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.QAQC_PASSED_UPDATE_REQUEST });
            const res = await Service.qaQcPassedUpdate(id, params);
            if (res && res.status === 200) {
                const updateReview = res.data;
                if (updateReview.success) {
                    dispatch({
                        type: actionTypes.QAQC_PASSED_UPDATE_SUCCESS,
                        response: updateReview
                    });
                } else {
                    dispatch({
                        type: actionTypes.QAQC_PASSED_UPDATE_FAILURE,
                        error: updateReview
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.QAQC_PASSED_UPDATE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.QAQC_PASSED_UPDATE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getRecommendationReviewById = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RECOMMENDATION_REVIEW_BY_ID_REQUEST });
            const res = await Service.getRecommendationReviewById(id);
            if (res && res.status === 200) {
                const qaQcReview = res.data;
                if (qaQcReview.success) {
                    dispatch({
                        type: actionTypes.GET_RECOMMENDATION_REVIEW_BY_ID_SUCCESS,
                        response: qaQcReview
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_RECOMMENDATION_REVIEW_BY_ID_FAILURE,
                        error: qaQcReview
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_RECOMMENDATION_REVIEW_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_RECOMMENDATION_REVIEW_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const addReviewComment = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_REVIEW_COMMENT_REQUEST });
            const res = await Service.addReviewComment(params);
            if (res && res.status === 200) {
                const updateReview = res.data;
                if (updateReview.success) {
                    dispatch({
                        type: actionTypes.ADD_REVIEW_COMMENT_SUCCESS,
                        response: updateReview
                    });
                } else {
                    dispatch({
                        type: actionTypes.ADD_REVIEW_COMMENT_FAILURE,
                        error: updateReview
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.ADD_REVIEW_COMMENT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ADD_REVIEW_COMMENT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const createAssetRecommendationAction = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.CREATE_ASSET_RECOMMENDATION_REQUEST });
            const res = await Service.createAssetRecommendation(id);
            if (res && res.status === 200) {
                const resData = res.data;
                if (resData.success) {
                    dispatch({
                        type: actionTypes.CREATE_ASSET_RECOMMENDATION_SUCCESS,
                        response: resData
                    });
                } else {
                    dispatch({
                        type: actionTypes.CREATE_ASSET_RECOMMENDATION_FAILURE,
                        error: resData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.CREATE_ASSET_RECOMMENDATION_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.CREATE_ASSET_RECOMMENDATION_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const shiftCspYears = (params, id) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.SHIFT_CSP_YEAR_REQUEST });
            const res = await Service.shiftCspYears(id, params);
            if (res && res.status === 200) {
                const resData = res.data;
                if (resData.success) {
                    dispatch({
                        type: actionTypes.SHIFT_CSP_YEAR_SUCCESS,
                        response: resData
                    });
                } else {
                    dispatch({
                        type: actionTypes.SHIFT_CSP_YEAR_FAILURE,
                        error: resData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.SHIFT_CSP_YEAR_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.SHIFT_CSP_YEAR_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getSourceYears = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SOURCE_YEARS_REQUEST });
            const res = await Service.getSourceYears(params);
            if (res && res.status === 200) {
                const resData = res.data;
                if (resData.success) {
                    dispatch({
                        type: actionTypes.GET_SOURCE_YEARS_SUCCESS,
                        response: resData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_SOURCE_YEARS_FAILURE,
                        error: resData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_SOURCE_YEARS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SOURCE_YEARS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const clearEntityParams = section => {
    return async dispatch => {
        dispatch({ type: actionTypes.CLEAR_ENTITY_PARAMS });
    };
};
const normalRecomGrouping = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.NORMAL_RECOM_GROUPING_REQUEST });
            const response = await Service.normalRecomGrouping(params);
            // Returned outcome ({ status: "downloaded" | "queued" | "error" }) mirrors exportRecommendations,
            // so Otto (table_view export) reports what actually happened. The lone caller previously ignored
            // the return (the old error path returned a bare `true`), so the change is additive.
            if (response?.status === 201) {
                if (response && response.data) {
                    const text = await new Response(response.data).text();
                    if (text && text.split('"')[1] === "error") {
                        dispatch({ type: actionTypes.NORMAL_RECOM_GROUPING_FAILURE, response: { error: text.split('"')[3] } });
                        return { status: "error", message: text.split('"')[3] };
                    } else {
                        dispatch({ type: actionTypes.NORMAL_RECOM_GROUPING_SUCCESS, response: {} });
                    }
                }
                const { data } = response;
                const name = response.headers["content-disposition"].split("filename=");
                let fileName = name[1];
                let downloadUrl = "";
                if (params?.is_excel) {
                    let url = window.URL || window.webkitURL;
                    downloadUrl = url.createObjectURL(new Blob([data]));
                } else {
                    fileName = name[1].split('"')[1];
                    downloadUrl = window.URL.createObjectURL(new Blob([data]));
                }
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", `${fileName}`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                return { status: "downloaded" };
            } else if (response?.status === 200) {
                dispatch({
                    type: actionTypes.NORMAL_RECOM_GROUPING_SUCCESS,
                    response: { message_status: "Export Initiated, Please check Export History Later", message: response?.data?.message }
                });
                return { status: "queued" };
            } else {
                dispatch({ type: actionTypes.NORMAL_RECOM_GROUPING_FAILURE, error: response?.data });
                return { status: "error" };
            }
        } catch (e) {
            dispatch({
                type: actionTypes.NORMAL_RECOM_GROUPING_FAILURE,
                error: e.response && e.response.data
            });
            return { status: "error" };
        }
    };
};

const getRecommendationsLog = (params, pagination) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_RECOMMENDATIONS_LOG_REQUEST });
            const res = await Service.getRecommendationsLog(params, pagination);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData) {
                    dispatch({
                        type: actionTypes.GET_ALL_RECOMMENDATIONS_LOG_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_ALL_RECOMMENDATIONS_LOG_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_RECOMMENDATIONS_LOG_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_RECOMMENDATIONS_LOG_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAllMobileRecommendations = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_MOBILE_RECOMMENDATIONS_REQUEST });
            const res = await Service.getAllMobileRecommendations(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_ALL_MOBILE_RECOMMENDATIONS_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_ALL_MOBILE_RECOMMENDATIONS_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_MOBILE_RECOMMENDATIONS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_RECOMMENDATIONS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const searchAndReplaceRecommendation = (params, cb) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.SEARCH_AND_REPLACE_RECOMMENDATION_REQUEST });
            const res = await Service.searchAndReplaceRecommendation(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.SEARCH_AND_REPLACE_RECOMMENDATION_SUCCESS,
                    response: responseData
                });
                cb && cb(responseData);
            } else {
                dispatch({
                    type: actionTypes.SEARCH_AND_REPLACE_RECOMMENDATION_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.SEARCH_AND_REPLACE_RECOMMENDATION_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const findRecommendationsBeforeReplace = (params, cb) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.FIND_RECOMMENDATION_BEFORE_REPLACE_REQUEST });
            const res = await Service.findRecommendationsBeforeReplace(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.FIND_RECOMMENDATION_BEFORE_REPLACE_SUCCESS,
                    response: responseData
                });
                cb && cb();
            } else {
                dispatch({
                    type: actionTypes.FIND_RECOMMENDATION_BEFORE_REPLACE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.FIND_RECOMMENDATION_BEFORE_REPLACE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getRecomGroupEditProgress = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_RECOM_GROUP_EDIT_PROGRESS_REQUEST });
            const res = await Service.getGroupEditProgress(id, params);
            if (res && res.status === 200) {
                const responseData = res.data;
                if (responseData.success) {
                    dispatch({ type: actionTypes.GET_RECOM_GROUP_EDIT_PROGRESS_SUCCESS, response: responseData });
                } else {
                    dispatch({ type: actionTypes.GET_RECOM_GROUP_EDIT_PROGRESS_FAILURE, error: responseData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_RECOM_GROUP_EDIT_PROGRESS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_RECOM_GROUP_EDIT_PROGRESS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const resetRecomGroupEditReducer = () => {
    return async dispatch => {
        try {
            dispatch({
                type: actionTypes.RESET_RECOM_GROUP_EDIT_PROGRESS_REDUCER_SUCCESS
            });
        } catch (e) {
            dispatch({
                type: actionTypes.RESET_RECOM_GROUP_EDIT_PROGRESS_REDUCER_FAILURE
            });
        }
    };
};

const getRecommendationsLogDetails = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_RECOMMENDATIONS_LOG_DETAILS_REQUEST });
            const res = await Service.getRecommendationsLogDetails(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData) {
                    dispatch({
                        type: actionTypes.GET_ALL_RECOMMENDATIONS_LOG_DETAILS_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_ALL_RECOMMENDATIONS_LOG_DETAILS_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_RECOMMENDATIONS_LOG_DETAILS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_RECOMMENDATIONS_LOG_DETAILS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getListForCommonFilterRecommendationLog = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LIST_FOR_RECOMMENDATION_LOG_COMMON_FILTER_REQUEST });
            const res = await Service.getRecommendationLogDropdown(params);
            if (res && res.status === 200) {
                const siteData = res.data;
                if (siteData.success) {
                    dispatch({
                        type: actionTypes.GET_LIST_FOR_RECOMMENDATION_LOG_COMMON_FILTER_SUCCESS,
                        response: siteData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_LIST_FOR_RECOMMENDATION_LOG_COMMON_FILTER_FAILURE,
                        error: siteData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_LIST_FOR_RECOMMENDATION_LOG_COMMON_FILTER_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const logExport = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_EXPORT_LOG_DATA_REQUEST });
            const response = await Service.logExport(params);
            if (response && response.data) {
                const text = await new Response(response.data).text();
                if (text && text.split('"')[1] === "error") {
                    dispatch({ type: actionTypes.GET_EXPORT_LOG_DATA_SUCCESS, response: { error: text.split('"')[3] } });
                    return true;
                } else {
                    dispatch({ type: actionTypes.GET_EXPORT_LOG_DATA_SUCCESS, response: {} });
                }
            }
            const { data } = response;
            const name = response.headers["content-disposition"].split("filename=");
            const fileName = name[1].split('"')[1];
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {}
    };
};

const deleteExportHistory = (id, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_IMPORT_VIEW_TABLE_REQUEST });
            const res = await Service.deleteExportHistory(id, source);
            if (res && res.status === 200) {
                const data = res?.data;
                if (data?.success) {
                    dispatch({ type: actionTypes.DELETE_IMPORT_VIEW_TABLE_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.DELETE_IMPORT_VIEW_TABLE_FAILURE, error: data });
                }
            } else {
                dispatch({
                    type: actionTypes.DELETE_IMPORT_VIEW_TABLE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_IMPORT_VIEW_TABLE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const sendRecomEmailNotification = (text, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.SEND_RECOM_EMAIL_NOTIFICATION_REQUEST });
            const res = await Service.sendRecomEmailNotification(text, params);
            if (res && (res.status === 200 || res.status === 201)) {
                const resData = res.data;
                dispatch({ type: actionTypes.SEND_RECOM_EMAIL_NOTIFICATION_SUCCESS, response: resData });
            } else {
                dispatch({
                    type: actionTypes.SEND_RECOM_EMAIL_NOTIFICATION_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.SEND_RECOM_EMAIL_NOTIFICATION_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const linkRecommendationsToCapitalRequest = ({ capital_request_id, recommendation_ids }) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.LINK_RECOMMENDATIONS_TO_CAPITAL_REQUEST_REQUEST });
            const res = await Service.linkRecommendationsToCapitalRequest(capital_request_id, { recommendation_ids });
            if (res && res.status === 200 && res.data.success) {
                dispatch({ type: actionTypes.LINK_RECOMMENDATIONS_TO_CAPITAL_REQUEST_SUCCESS, response: res.data });
                return { success: true, ...res.data };
            }
            const error = res.response?.data ?? res.data;
            dispatch({ type: actionTypes.LINK_RECOMMENDATIONS_TO_CAPITAL_REQUEST_FAILURE, error });
            return { success: false, ...error };
        } catch (e) {
            const error = e.response?.data ?? { message: ERROR_COPY.GENERIC };
            dispatch({ type: actionTypes.LINK_RECOMMENDATIONS_TO_CAPITAL_REQUEST_FAILURE, error });
            return { success: false, ...error };
        }
    };
};

const unlinkRecommendationsFromCapitalRequest = ({ capital_request_id, recommendation_ids }) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UNLINK_RECOMMENDATIONS_FROM_CAPITAL_REQUEST_REQUEST });
            const res = await Service.unlinkRecommendationsFromCapitalRequest(capital_request_id, { recommendation_ids });
            if (res && res.status === 200 && res.data.success) {
                dispatch({ type: actionTypes.UNLINK_RECOMMENDATIONS_FROM_CAPITAL_REQUEST_SUCCESS, response: res.data });
                return { success: true, ...res.data };
            }
            const error = res.response?.data ?? res.data;
            dispatch({ type: actionTypes.UNLINK_RECOMMENDATIONS_FROM_CAPITAL_REQUEST_FAILURE, error });
            return { success: false, ...error };
        } catch (e) {
            const error = e.response?.data ?? { message: ERROR_COPY.GENERIC };
            dispatch({ type: actionTypes.UNLINK_RECOMMENDATIONS_FROM_CAPITAL_REQUEST_FAILURE, error });
            return { success: false, ...error };
        }
    };
};

export default {
    getAllRecommendations,
    addRecommendation,
    updateRecommendation,
    deleteRecommendation,
    getRegionsBasedOnClient,
    getBuildingsBasedOnSite,
    getAllConsultancyUsers,
    getAllClientsRecomentation,
    getRecommendationById,
    uploadRecommendationImage,
    getAllRecommendationImages,
    getCategoryBasedOnProject,
    deleteRecommendationImage,
    getSystemBasedOnProject,
    getFloorBasedOnBuilding,
    getSubSystemBasedOnProject,
    getTradeBasedOnProject,
    updateRecommendationImageComment,
    updateRecommendationEntityParams,
    getListForCommonFilterrecommendation,
    getCostYearByProject,
    getAllRecommendationsRegion,
    getFundingSourceByProject,
    getSpaceType,
    updateMaintenanceYearCutPaste,
    exportRecommendations,
    exportRecommendationByRegion,
    exportRecommendationBySite,
    exportRecommendationByBuilding,
    getRestoreRecommendation,
    getConditionBasedOnProject,
    getAllRecommendationLogs,
    restoreRecommendationLog,
    deleteRecommendationLog,
    getInitiativeDropdown,
    getReportNoteTemplates,
    downloadPdfReport,
    addUserActivityLog,
    getAdditionBasedOnBuilding,
    assignImagesToRecom,
    exportAllTrades,
    unAssignImage,
    updateBudgetPriority,
    updateRecommendationImageSort,
    getAllBudgetPriorityRecommendations,
    exportBudgetPriorityRecommendations,
    getListForBudgetPriorityFilter,
    setRecommendationScrollPosition,
    getRecommendationTemplates,
    getUserDefaultTrade,
    updateMultipleRecommendations,
    updateFMP,
    getRecommendationCommonDataByIds,
    getAllRecommendationIds,
    getPriorityElementDropDownData,
    updateIR,
    exportReportPdf,
    updateRL,
    updateContinuousFCA,
    getCapitalTypeBasedOnProject,
    exportSelectedRecomWord,
    exportSelectedRecomPDF,
    getCriticalityDropDownData,
    exportToWord,
    getCapitalTypeDropDownData,
    getImportViewTableModal,
    updateNoteImportViewTableModal,
    exportToExcel,
    exportToExcelFile,
    getExportRecom,
    postExportRecom,
    getExportPropertyDropdown,
    getResponsibilityByProject,
    getRecommendationAcceptableVerbsByProject,
    getDynamicFields,
    createQaQcIssue,
    getAllRecommendationReviews,
    updateRecommendationReview,
    updateRecommendationReviewStatusReviewer,
    updateRecommendationReviewStatusUser,
    deleteRecommendationReview,
    sendQaQcAllNotification,
    sendReviewNotification,
    qaQcPassedUpdate,
    getRecommendationReviewById,
    addReviewComment,
    createAssetRecommendationAction,
    shiftCspYears,
    getSourceYears,
    clearEntityParams,
    normalRecomGrouping,
    getRecommendationsLog,
    getAllMobileRecommendations,
    searchAndReplaceRecommendation,
    getRecomGroupEditProgress,
    resetRecomGroupEditReducer,
    findRecommendationsBeforeReplace,
    getRecommendationsLogDetails,
    getListForCommonFilterRecommendationLog,
    logExport,
    deleteExportHistory,
    sendRecomEmailNotification,
    linkRecommendationsToCapitalRequest,
    unlinkRecommendationsFromCapitalRequest
};
